import { ColorIcons as Icons } from "@codesandbox/template-icons";
import { Icon } from "prism-react";

function getUserIcon(
  templateName: string,
  iconUrl: string | undefined,
): React.FunctionComponent<{ width?: number; height?: number }> | undefined {
  if (!iconUrl) {
    return undefined;
  }

  if (iconUrl === "github") {
    return ({ width, height }) => (
      <Icon css={{ width, height }} type="github" />
    );
  }

  if (iconUrl.startsWith("https://")) {
    return ({ width, height }) => (
      <img alt={templateName} height={height} src={iconUrl} width={width} />
    );
  }

  // @ts-expect-error this is a dynamic import
  return Icons[iconUrl];
}

export type TemplateIconProps = {
  width?: number;
  height?: number;
  iconUrl?: string;
  templateName: string;
};

export const TemplateIcon: React.FC<TemplateIconProps> = ({
  templateName,
  iconUrl,
  width,
  height,
}) => {
  const UserIcon: React.FunctionComponent<{ width?: number; height?: number }> =
    getUserIcon(templateName, iconUrl) || Icons.ReactIcon;

  return <UserIcon height={height} width={width} />;
};
